export * from './PermissionsPromptText';
